/** Staff and admin. Customers are everyone else. */
export function isStaff(user: { role: string | null | undefined }): boolean {
  return user.role === "staff" || user.role === "admin";
}
